module.exports = __webpack_public_path__ + "img/automatic_bottom_lock_box2.dc157185.png";